<template>
    <div class="report_detail" v-if="detail">
        <p>{{detail.txt1}}</p>
        <div class="energy_analysis-wrap">
            <el-table
                :data="detail.originalResultParam"
                border
                class="repot-table"
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                style="width: 100%"
            >
                <el-table-column prop="outDiameter">
                    <template slot="header">
                        <div>管径<br>(mm)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="oneInsulaType">
                    <template slot="header">
                        <div>内层保温<br>材料</div>
                    </template>
                </el-table-column>
                <el-table-column prop="oneInsulaThick">
                    <template slot="header">
                        <div>内层保温厚度<br>（mm）</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="twoInsulaType">
                    <template slot="header">
                        <div>外层保温材料<br></div>
                    </template>
                </el-table-column>
                 <el-table-column prop="twoInsulaThick">
                    <template slot="header">
                        <div>外层保温厚度<br>（mm）</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <p>{{detail.txt2}}</p>
        <div class="energy_analysis-wrap">
            <el-table
                :data="detail.originalResult"
                border
                class="repot-table"
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                style="width: 100%"
            >
                <el-table-column prop="averTempe2">
                    <template slot="header">
                        <div>出口侧平均温度<br>(℃)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averTempeDrop">
                    <template slot="header">
                        <div>平均温降<br>(℃)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averH">
                    <template slot="header">
                        <div>出口侧平均焓值<br>(KJ/Kg)</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="averHLoss">
                    <template slot="header">
                        <div>平均焓降<br>(KJ/Kg)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averHeatLossPerSquare2">
                    <template slot="header">
                        <div>保温层外表面平均散热损失<br>(w/m^2)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumFlowMass">
                    <template slot="header">
                        <div>总质量流量<br>(t)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumheat">
                    <template slot="header">
                        <div>总热能<br>(GJ)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumheatLoss">
                    <template slot="header">
                        <div>总热损失<br>(GJ)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumheatLossRate">
                    <template slot="header">
                        <div>总热损率<br>(%)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averVelocity">
                    <template slot="header">
                        <div>平均流速<br>(m/s)</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <p>{{detail.txt3}}</p>   
        <div class="energy_analysis-wrap">
            <el-table
                :data="detail.originalTheoryResult"
                border
                class="repot-table"
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                style="width: 100%"
            >
                <el-table-column prop="averTempe2Theory">
                    <template slot="header">
                        <div>出口侧平均温度<br>(℃)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averTempeDropTheory">
                    <template slot="header">
                        <div>平均温降<br>(℃)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averHTheory">
                    <template slot="header">
                        <div>出口侧平均焓值<br>(KJ/Kg)</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="averHLossTheory">
                    <template slot="header">
                        <div>平均焓降<br>(KJ/Kg)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averHeatLossPerSquare2Theory">
                    <template slot="header">
                        <div>保温层外表面平均散热损失<br>(w/m^2)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumFlowMassTheory">
                    <template slot="header">
                        <div>总质量流量<br>(t)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumHeat">
                    <template slot="header">
                        <div>总热能<br>(GJ)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumHeatLossTheory">
                    <template slot="header">
                        <div>总热损失<br>(GJ)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumHeatLossRateTheory">
                    <template slot="header">
                        <div>总热损率<br>(%)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averVelocityTheory">
                    <template slot="header">
                        <div>平均流速<br>(m/s)</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <p>{{detail.txt5}}</p>       
        <div class="energy_analysis-wrap">
            <el-table
                :data="detail.newInsulaParam"
                border
                class="repot-table"
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                style="width: 100%"
            >
                <el-table-column prop="insulaId">
                    <template slot="header">
                        <div>方案</div>
                    </template>
                </el-table-column>
                <el-table-column prop="oneInsulaTheoryType">
                    <template slot="header">
                        <div>内层保温材料</div>
                    </template>
                </el-table-column>
                <el-table-column prop="oneInsulaTheoryThick">
                    <template slot="header">
                        <div>保温厚度(mm)</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="twoInsulaTheoryType">
                    <template slot="header">
                        <div>外层保温材料</div>
                    </template>
                </el-table-column>
                <el-table-column prop="twoInsulaTheoryThick">
                    <template slot="header">
                        <div>保温厚度(mm)</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <p>{{detail.txt4}}</p>
        <div class="energy_analysis-wrap">
            <el-table
                :data="detail.result"
                border
                class="repot-table"
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                style="width: 100%"
            >
                <el-table-column prop="Id">
                    <template slot="header">
                        <div>方案</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averTempeTheory">
                    <template slot="header">
                        <div>出口侧平均温度<br>（℃）</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averTempeDropTheory">
                    <template slot="header">
                        <div>平均温降<br>（℃）</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="averHTheory">
                    <template slot="header">
                        <div>出口侧平均焓值<br>（KJ/Kg)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averHLossTheory">
                    <template slot="header">
                        <div>平均焓降<br>(KJ/Kg）</div>
                    </template>
                </el-table-column>
                <el-table-column prop="averHeatLossPerSquare2Theory">
                    <template slot="header">
                        <div>保温材料散热损失平均值<br>(w/m^2)</div>
                    </template>
                </el-table-column>
                 <el-table-column prop="GSaving">
                    <template slot="header">
                        <div>总热损节省量<br>(GJ)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="HeatlossSavingRate">
                    <template slot="header">
                        <div>总热损节省率<br>(%)</div>
                    </template>
                </el-table-column>
                <el-table-column prop="sumHeatLossRateTheory">
                    <template slot="header">
                        <div>总热损率<br>（%）</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <p>{{detail.txt6}}</p>
    </div>
</template>
<script>
// 管径分析报告
export default {
    name:"DiameterDetail",
    props:["detail"]
}
</script>
<style lang="scss">
.report_detail{
    .repot-table{
        td,th{
            text-align: center;
        }
    }
}
</style>